import { useConfigurationOptionsContext } from "app/providers/DoorOptionsProvider";
import { WidthSimpleButton } from "../measurements-option-controls/components/WidthSimpleButton";

const selectableKozijnOptions = [
  { text: "Op enkel glas", code: "op-enkel-glas" },
  { text: "Op dubbel glas", code: "op-dubbel-glas" },
  { text: "Op dichte wand", code: "op-dichte-wand" },
];

export const AansluitingKozijnOptions = () => {
  const { selfAssembleDoorData, updateSelfAssembleData, updateSearchParam } =
    useConfigurationOptionsContext();

  const setFrameConnection = (connection: string) => {
    let data = { ...selfAssembleDoorData };
    data.measurements.frameConnection = connection;

    updateSearchParam("frameConnection", connection);
    updateSelfAssembleData(data);
  };
  return (
    <>
      <div>
        <div
          data-testid="width-kaderdeur-buttons"
          className="gg-mt-0.5 gg-grid gg-grid-cols-3 gg-gap-x-5 gg-gap-y-4"
        >
          {selectableKozijnOptions.map((option, index) => (
            <WidthSimpleButton
              key={index}
              onClick={() => setFrameConnection(option.code)}
              isActive={
                selfAssembleDoorData.measurements.frameConnection ===
                option.code
              }
            >
              {option.text}
            </WidthSimpleButton>
          ))}
        </div>
      </div>
    </>
  );
};
